import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
    createJob,
    deleteJob,
    getJobs,
    getSingleJob,
    updateJob,
} from "./jobsApi";

const initialState = {
    jobs: [],
    job: {},
    isLoading: false,
    isError: false,
    error: "",
};

// async thunk
export const fetchJobs = createAsyncThunk("jobs/fetchJobs", async (text) => {
    const jobs = await getJobs(text);
    return jobs;
});

export const fetchSingleJob = createAsyncThunk(
    "jobs/fetchSingleJob",
    async (jobId) => {
        const job = await getSingleJob(jobId);
        return job;
    }
);

export const addJob = createAsyncThunk("jobs/addJob", async (data) => {
    const job = await createJob(data);
    return job;
});

export const changeJob = createAsyncThunk(
    "jobs/changeJob",
    async ({ id, data }) => {
        const job = await updateJob(id, data);
        return job;
    }
);

export const removeJob = createAsyncThunk("jobs/removeJob", async (jobId) => {
    const job = await deleteJob(jobId);
    return job;
});

const jobsSlice = createSlice({
    name: "jobs",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(fetchJobs.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(fetchJobs.fulfilled, (state, action) => {
                state.isError = false;
                state.isLoading = false;
                state.job = {};
                state.jobs = action.payload;
            })
            .addCase(fetchJobs.rejected, (state, action) => {
                state.isLoading = false;
                state.jobs = [];
                state.job = {};
                state.isError = true;
                state.error = action.error?.message;
            })
            .addCase(fetchSingleJob.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(fetchSingleJob.fulfilled, (state, action) => {
                state.isError = false;
                state.isLoading = false;
                state.job = action.payload;
            })
            .addCase(fetchSingleJob.rejected, (state, action) => {
                state.isLoading = false;
                state.job = {};
                state.isError = true;
                state.error = action.error?.message;
            })
            .addCase(addJob.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(addJob.fulfilled, (state, action) => {
                state.isError = false;
                state.isLoading = false;
                state.job = {};
                state.jobs.push(action.payload);
            })
            .addCase(addJob.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.job = {};
                state.error = action.error?.message;
            })
            .addCase(changeJob.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(changeJob.fulfilled, (state, action) => {
                state.isError = false;
                state.isLoading = false;
                state.job = {};
                const indexToUpdate = state.jobs.findIndex(
                    (job) => job.id === action.payload.id
                );
                state.jobs[indexToUpdate] = action.payload;
            })
            .addCase(changeJob.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.error = action.error?.message;
            })
            .addCase(removeJob.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(removeJob.fulfilled, (state, action) => {
                state.isError = false;
                state.isLoading = false;
                state.job = {};
                state.jobs = state.jobs.filter(
                    (job) => job.id !== action.meta.arg
                );
            })
            .addCase(removeJob.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.error = action.error?.message;
            });
    },
});

export default jobsSlice.reducer;
